import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from '../../Modal';

const ConfirmModal = ({
  close,
  confirm,
  negative,
  message,
  title,
  type,
  confirmButtonText,
  negativeButtonText,
  showNegativeButton,
  showConfirmButton,
  className,
}) => (
  <Modal
    title={title}
    close={close}
    showCloseButton
    className={className}
  >
    <div
      className={classnames('c-modal__text u-max-width-600 u-pv u-margin-auto', {
        'u-fontsize-medium': type === 'danger',
      })}
    >
      {message}
    </div>
    <div className="u-text-right u-mv u-mr">
      <button
        display-if={showNegativeButton}
        type="button"
        className={classnames('c-btn u-width-120 u-mr', {
          'c-btn--red': type === 'yesno',
          'c-btn--grey': type === 'default' || type === 'defaultSafe',
        })}
        onClick={negative}
      >
        {negativeButtonText}
      </button>
      <button
        display-if={showConfirmButton}
        type="button"
        className={classnames('c-btn u-width-120', {
          'c-btn--red': type === 'danger' || type === 'yesnoreverse' || type === 'default',
        })}
        onClick={confirm}
      >
        {confirmButtonText}
      </button>
    </div>
  </Modal>
);

ConfirmModal.propTypes = {
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  negative: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['default', 'danger', 'yesno', 'yesnoreverse', 'defaultSafe']),
  confirmButtonText: PropTypes.string,
  negativeButtonText: PropTypes.string,
  showConfirmButton: PropTypes.bool,
  showNegativeButton: PropTypes.bool,
  className: PropTypes.string,
};
ConfirmModal.defaultProps = {
  type: 'default',
  confirmButtonText: 'OK',
  negativeButtonText: 'Cancel',
  showConfirmButton: true,
  showNegativeButton: true,
  className: '',
};

export default ConfirmModal;
